import { render, staticRenderFns } from "./HistoryPerson.vue?vue&type=template&id=154a0300"
import script from "./HistoryPerson.vue?vue&type=script&lang=js"
export * from "./HistoryPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports